import type { LrtReportId } from '@brightlocal/shared';

import {
  LRTCreateReportResponseSchema,
  LRTHistorySchema,
  LRTReportSchema,
  LRTResultSchema,
  LRTRunReportResponseSchema
} from './schema';
import type { LRTCreateReportSettings, LRTGetHistoryParams, LRTGetResultParams } from './schema';
import { HTTP_METHOD } from '../../../consts';
import type { ApiCallOptions, Transport } from '../../../types';

export const createLRTReportApi = (transport: Transport) => ({
  createReport: (settings: LRTCreateReportSettings, options?: ApiCallOptions) =>
    transport(`/manage/v1/lrt/reports`, {
      method: HTTP_METHOD.POST,
      body: settings,
      deserializer: LRTCreateReportResponseSchema,
      signal: options?.signal
    }),
  runReport: (reportId: LrtReportId, options?: ApiCallOptions) =>
    transport(`/manage/v1/lrt/reports/${reportId}/actions/run`, {
      method: HTTP_METHOD.POST,
      deserializer: LRTRunReportResponseSchema,
      signal: options?.signal
    }),
  getReport: (reportId: LrtReportId, options?: ApiCallOptions) =>
    transport(`/manage/v1/lrt/reports/${reportId}`, {
      method: HTTP_METHOD.GET,
      deserializer: LRTReportSchema,
      signal: options?.signal
    }),
  getResult: (reportId: LrtReportId, params?: LRTGetResultParams, options?: ApiCallOptions) =>
    transport(`/manage/v1/lrt/reports/${reportId}/result`, {
      method: HTTP_METHOD.GET,
      deserializer: LRTResultSchema,
      signal: options?.signal,
      queryParams: params?.campaignHistoryId != null ? { campaign_history_id: params.campaignHistoryId } : undefined
    }),
  getHistory: (reportId: LrtReportId, params?: LRTGetHistoryParams, options?: ApiCallOptions) =>
    transport(`/manage/v1/lrt/reports/${reportId}/history`, {
      method: HTTP_METHOD.GET,
      deserializer: LRTHistorySchema,
      signal: options?.signal,
      queryParams:
        params === undefined
          ? undefined
          : { statuses: params.statuses, date_after: params.dateAfter, fields: params.fields }
    })
});

export type LRTReportApi = ReturnType<typeof createLRTReportApi>;
